module.exports = __webpack_public_path__ + "static/floorplan_03-85dcf3c8d22b87af97253f525a3a314b.jpg";